export enum SelectionType {
  START = 'START',
  BEGIN = 'BEGIN',
  END = 'END',
}
